<script setup>
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import {inject, onMounted, ref, watch} from "vue";
import searchFilterOptions from "../../../../../frontend/src/constants/searchFilterOptions";

const employeesCountOptions = [
    ...searchFilterOptions.employeeCount,
    {
        name: "501-1000",
        value: {
            min: 501,
            max: 1000
        }
    },
    {
        name: "1001-5000",
        value: {
            min: 1001,
            max: 5000
        }
    },
    {
        name: "5001-10000",
        value: {
            min: 5001,
            max: 10000
        }
    },
    {
        name: "> 10000",
        value: {
            min: 10000,
        }
    }
]

const form = inject("form");
const employees = ref(null);

onMounted(() => {
    if (form.numEmployeesMin || form.numEmployeesMax) {
        employees.value = employeesCountOptions.find(item =>
            item.value.min === parseInt(form.numEmployeesMin) && (item.value.max === undefined || item.value.max === parseInt(form.numEmployeesMax))
        )
    }
});

watch(employees, value => {
    if (value) {
        form.numEmployeesMin = value.value.min
        form.numEmployeesMax = value.value.max
    } else {
        form.numEmployeesMin = null
        form.numEmployeesMax = null
    }
})

</script>

<template>
    <div>
        <StartupEditField
            field-name="numEmployeesMin"
            v-model="employees"
            label="Employees"
            :options="employeesCountOptions"
        />
    </div>
</template>

<style scoped>

</style>
